/**
 * Routes used for authentication. These are locked by other parts of the
 * Bracken infrastructure.
 */
export const IdentityRoutes = {
  /** Route configured by Identity Service to register a new account. */
  REGISTER: '/registration',
  /** Route configured by membership service to verify an email. */
  VERIFY_EMAIL: '/verify-email',
  /** Request a new verification email. */
  REQUEST_VERIFICATION: '/request-verification-email',
  /** Route to request an email reset. */
  REQUEST_PASSWORD: '/request-password-reset',
  /** Reset the password. */
  RESET_PASSWORD: '/reset-my-password',
  /** Accept an invitation. */
  INVITATION: '/invitation'
};
